module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTUxMiA2NGMyNDcuNCAwIDQ0OCAyMDAuNiA0NDggNDQ4cy0yMDAuNiA0NDgtNDQ4IDQ0OFM2NCA3NTkuNCA2NCA1MTIgMjY0LjYgNjQgNTEyIDY0eiBtLTY0IDI4My44YTMyIDMyIDAgMCAwLTMxLjggMjguM2wtMC4yIDMuN3YyNjQuNGEzMiAzMiAwIDAgMCA0Ni41IDI4LjVsMy4yLTEuOSAxOTguMy0xMzIuMmEzMiAzMiAwIDAgMCAzLTUxbC0zLTIuMi0xOTguMy0xMzIuMkEzMiAzMiAwIDAgMCA0NDggMzQ3Ljh6IiBmaWxsPSIjMCIgcC1pZD0iNDAxOSI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Play-filled.svg
// module id = NdU9
// module chunks = 75